import {
    apiRequest,
    rumpunDetail
} from "../../../../../services/adapters/kepegawaian/rumpunService"

class DetailRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", rumpunDetail, {
            params: query
        }, true)
    }
}

export default DetailRepository